<template>
  <sui-form-field>
    <sui-menu attached="top" color="blue">
      <a class="item" :class="{active: active === index}" v-for="(config, index) in $attrs.value" :key="index" @click="openConfig(config.name)">
        <CopyIcon :value="config.name" data-inverted data-tooltip="Copy path" data-goal="SERVICE_FORM_CONFIGS_COPY_PATH" />
        {{config.name}}
        <span class="delete-button" data-inverted data-tooltip="Delete config" v-show="config.custom">
          <i class="times fitted icon" @click.stop="deleteConfig(config.name)" />
        </span>
      </a>
      <sui-menu-item :class="{error: newNameChecking && hasNameError}" fitted>
        <div class="ui transparent icon input" :data-tooltip="hasNameError && nameError">
          <input class="newname-input" ref="newName" v-model.trim="newName" :placeholder="inputPlaceholder" @focus="onFocusNewName()" @input="onChangeNewName()" @keyup.enter="confirmNewConfig()" />
          <i class="newname-icon link icon" :class="inputIcon" @click="confirmNewConfig()" />
        </div>
      </sui-menu-item>
    </sui-menu>
    <sui-segment attached="bottom">
      <div class="config" :class="{readonly: previewing}" v-if="activeConfig">
        <sui-segment class="fitted" basic>
          <codemirror ref="editor" v-model="$attrs.value[active][contentField]" :options="editorOptions" v-if="!previewing" @cursorActivity="onSelect()" @ready="onCmReady" @focus.once="onFocus" />
          <codemirror ref="preview" :value="preview" :options="previewOptions" v-if="previewing" @cursorActivity="onSelect()" @ready="onCmReady" />
          <div class="config-buttons">
            <div class="ui red mini icon button" data-inverted data-tooltip="reset to default" v-show="!previewing && hasDefault" @click.prevent="resetConfig()">
              <i class="refresh icon" />
            </div>
            <div class="ui orange mini icon button" :class="{disabled: !hasChanges}" data-inverted data-tooltip="Cancel current changes" v-show="!previewing" @click.prevent="cancelChanges()">
              <i class="undo icon" />
            </div>
            <div class="ui blue mini icon button" data-inverted data-tooltip="Preview config" v-show="!previewing" @click.prevent="previewing = true">
              <i class="eye icon" />
            </div>
            <div class="ui blue mini icon button" data-inverted data-tooltip="Edit config" v-show="previewing" @click.prevent="previewing = false">
              <i class="pencil alternate icon" />
            </div>
          </div>
        </sui-segment>
        <sui-segment class="fitted" basic v-if="!activeConfig.custom">
          <div class="ui labels">
            <sui-label class="variable" size="small" v-for="(value, variable) in entityConfigVariables" :key="variable" data-inverted :data-tooltip="value || '<empty>'">
              {{variable}}
            </sui-label>
          </div>
        </sui-segment>
      </div>
      <div v-if="!$attrs.value.length">No config files</div>
    </sui-segment>
  </sui-form-field>
</template>

<script>
  import FormConfigs from '@/mixins/FormConfigs'
  import FormField from '@/mixins/FormField'

  export default {
    name: 'FormServiceConfigs',
    mixins: [
      FormConfigs,
      FormField,
    ],
    data() {
      return {
        addingConfig: false,
        newName: '',
        newNameChecking: false,
      }
    },
    computed: {
      nameError() {
        if (this.newName.length) {
          if (!/^[^<>:"|?*\\]*[^/<>:"|?*\\]$/.test(this.newName)) {
            return `Invalid config path`
          }
          if (this.$attrs.value.filter(config => config.name === this.newName).length) {
            return 'Dublicate config'
          }
        }
        return null
      },
      hasDefault() {
        return Boolean(this.field.default[this.active])
      },
      hasNameError() {
        return Boolean(this.newName.length && this.nameError)
      },
      inputPlaceholder() {
        return this.addingConfig ? 'Enter config path' : 'Add custom config'
      },
      inputIcon() {
        return this.addingConfig && this.newName ? 'level down alternate clockwise rotated' : 'plus'
      },
    },
    methods: {
      onCmReady(codemirror) {
        setTimeout(() => {
          codemirror.refresh()
        }, 1000)
      },
      onFocusNewName() {
        this.addingConfig = true
      },
      onChangeNewName() {
        this.newNameChecking = false
      },
      confirmNewConfig() {
        this.newNameChecking = true
        if (this.newName && !this.hasNameError) {
          this.$attrs.value.push({
            custom: true,
            name: this.newName,
            text: '',
          })
          this.newName = ''
          this.onInput()
        }
      },
      resetConfig() {
        this.setConfigField(this.field.default[this.active].text || '')
        this.focus()
      },
    },
  }
</script>

<style scoped>
  .menu { flex-wrap: wrap; border-bottom: none!important; background-color: #fafafa!important; }
  .menu .item { margin-left: -1px; margin-top: -1px; border-top: 1px solid #ddd; border-bottom: 1px solid #ddd; }
  .menu .item .times { opacity: .3!important; cursor: pointer; }
  .menu .item .times:hover { opacity: 1!important; color: #c00; }
  .menu .item .input { margin: .2em 0!important; }
  .input-item { margin-left: 0px!important; background-color: #fff!important; }
  .input-item.error { background-color: #fff6f6!important; }
  .input-item.error .newname-input { color: #9f3a38!important; }
  .newname-icon { margin-right: .7em!important; }
  .newname-input { padding-left: .7em!important; }
  .config-buttons { position: absolute; bottom: 1.3em; right: 1.2em; z-index: 2; }
  .variable:after { max-width: 200%; max-height: 400px; z-index: 1902; overflow: hidden; }
  .copy-button { margin-right: .3em!important; }
  .delete-button { margin-left: 1em!important; }
</style>
